import React, { useEffect } from 'react';
import Hero from '../Hero/Hero';
import HowItWorks from '../HowItWorks/HowItWorks';
import Testimonials from '../Testimonials/Testimonials';
import './Home.css';
import Services from '../Services/Services';
import Forces from '../Forces/Forces';
import { onAuthStateChanged } from 'firebase/auth';
import { auth, firestore } from '../../firebase/firebaseConfig';
import { onSnapshot, doc } from "firebase/firestore";

function Home ( props ) {

  function settingDetails ( name, phone, email, address ) {
    props.settingDetails( {
      name: name,
      phone: phone,
      email: email,
      address: address
    } )
  }

  useEffect( () => {
    document.querySelector( ".loader-container" ).style.display = "flex";
    onAuthStateChanged( auth, async ( user ) => {
      if ( user ) {
        onSnapshot( doc( firestore, "users", user.uid ), ( snapshot ) => {
          if ( snapshot.exists() ) {
            props.settingDetails( {
              name: snapshot.data().name,
              phone: snapshot.data().mobile,
              email: snapshot.data().email,
              address: snapshot.data().address,
              pincode: snapshot.data().pincode
            } )
          } else {
            window.location.href = "/signup";
          }
        } );
      }
    } );
    setTimeout( () => {
      document.querySelector( ".services-container swiper-container" ).shadowRoot.childNodes[ 4 ].style.backgroundColor = "transparent";
      document.querySelector( ".services-container swiper-container" ).shadowRoot.childNodes[ 4 ].childNodes[ 0 ].style.backgroundColor = "#66A9AFAD";
      document.querySelector( ".services-container swiper-container" ).shadowRoot.childNodes[ 4 ].childNodes[ 0 ].style.borderRadius = "5px";
      document.querySelector( ".how-it-works-inner-container swiper-container" ).shadowRoot.childNodes[ 4 ].style.backgroundColor = "transparent";
      document.querySelector( ".how-it-works-inner-container swiper-container" ).shadowRoot.childNodes[ 4 ].style.marginTop = "10px";
      document.querySelector( ".how-it-works-inner-container swiper-container" ).shadowRoot.childNodes[ 4 ].childNodes[ 0 ].style.backgroundColor = "#66A9AFAD";
      document.querySelector( ".how-it-works-inner-container swiper-container" ).shadowRoot.childNodes[ 4 ].childNodes[ 0 ].style.borderRadius = "5px";
      document.querySelector( ".loader-container" ).style.display = "none";
    }, 1000 );
  }, [] );

  return (
    <div className='home-container'>
      <Hero settingDetails={settingDetails} />
      <Services />
      <a href="https://play.google.com/store/apps/details?id=com.laundrybuddy.laundry_buddy" target="_blank" rel="noreferrer"><img src={require( "../../images/download-app-banner.webp" )} className='download-app-banner laptop' alt="" /></a>
      <a href="https://play.google.com/store/apps/details?id=com.laundrybuddy.laundry_buddy" target="_blank" rel="noreferrer"><img src={require( "../../images/registration-image-mobile.webp" )} className='download-app-banner mobile' alt="" /></a>
      <HowItWorks />
      <Forces />
      <Testimonials />
    </div>
  )
}

export default Home